/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query'
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query'
import { mutationOptionsWithInteraction } from '../../mutationOptions'
import { customInstance } from '../../mutator'
import type {
  HTTPValidationError,
  PlanarWallDTO,
  WallPlanSettingsUpdateDTO,
} from '../fastAPI.schemas'

/**
 * Store the plan settings of a wall.

Plan settings do not affect the structural model, so no model event is
raised; the wall is replaced in place, as for beams and wall positions.
 * @summary Update Wall Plan Settings
 */
export const updateWallPlanSettings = (
  projectGuid: string,
  wallGuid: string,
  wallPlanSettingsUpdateDTO: WallPlanSettingsUpdateDTO,
) => {
  return customInstance<PlanarWallDTO>({
    url: `/projects/${projectGuid}/planar-model/walls/${wallGuid}/plan-settings`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: wallPlanSettingsUpdateDTO,
  })
}

export const useUpdateWallPlanSettingsMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWallPlanSettings>>,
    TError,
    { projectGuid: string; wallGuid: string; data: WallPlanSettingsUpdateDTO },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateWallPlanSettings>>,
  TError,
  { projectGuid: string; wallGuid: string; data: WallPlanSettingsUpdateDTO },
  TContext
> => {
  const mutationKey = ['updateWallPlanSettings']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateWallPlanSettings>>,
    { projectGuid: string; wallGuid: string; data: WallPlanSettingsUpdateDTO }
  > = props => {
    const { projectGuid, wallGuid, data } = props ?? {}

    return updateWallPlanSettings(projectGuid, wallGuid, data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/projects/{projectGuid}/planar-model/walls/{wallGuid}/plan-settings` },
    {
      operationId:
        'update_wall_plan_settings_projects__project_guid__planar_model_walls__wall_guid__plan_settings_patch',
      operationName: 'updateWallPlanSettings',
    },
  )

  return customOptions
}

export type UpdateWallPlanSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateWallPlanSettings>>
>
export type UpdateWallPlanSettingsMutationBody = WallPlanSettingsUpdateDTO
export type UpdateWallPlanSettingsMutationError = HTTPValidationError

/**
 * @summary Update Wall Plan Settings
 */
export const useUpdateWallPlanSettings = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWallPlanSettings>>,
    TError,
    { projectGuid: string; wallGuid: string; data: WallPlanSettingsUpdateDTO },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof updateWallPlanSettings>>,
  TError,
  { projectGuid: string; wallGuid: string; data: WallPlanSettingsUpdateDTO },
  TContext
> => {
  const mutationOptions = useUpdateWallPlanSettingsMutationOptions(options)

  return useMutation(mutationOptions)
}
